import type {IModifyTemplateGraph} from "@cm/template-nodes"
import type {
    InitStackableMattressStandardModelMasterTemplateOptions,
    InitMattressInstanceTemplateOptions,
} from "#mattress/assets-definitions/standard-models/common/model-factory"
import {
    initInstanceTemplateCommon,
    initStackableMattressStandardModelMasterTemplate,
    getDefaultHandlesParameters,
} from "#mattress/assets-definitions/standard-models/common/model-factory"
import {createTemplateReference} from "#mattress/assets-definitions/common"

export function initSimplePocketMasterTemplate(
    modifyTemplateGraph: IModifyTemplateGraph,
    options: InitStackableMattressStandardModelMasterTemplateOptions = {openingOnBottom: false},
) {
    const optionsWithDefaults: InitStackableMattressStandardModelMasterTemplateOptions = {
        topPartFabricLayout: "Waterfall",
        bottomPartFabricLayout: "InvertedWaterfall",
        middlePartFabricLayout: "Border",
        ...options,
    }
    initStackableMattressStandardModelMasterTemplate(modifyTemplateGraph, optionsWithDefaults)
}

export function initSimplePocketInstanceTemplate(
    modifyTemplateGraph: IModifyTemplateGraph,
    masterTemplateDataLegacyId: number,
    options: InitMattressInstanceTemplateOptions,
) {
    const optionsParameters = {
        ...(options.parameters ? options.parameters : {}),
        width: 90,
        length: 200,
        "top-height": 10,
        "bottom-height": 10,
        "corner-radius": 2,
        "top-radius": 2,
        "bottom-radius": 2,
        "layer-count": 0,
        "accessories-bottom-curve/accessory-count": 1,
        "accessories-bottom-curve/accessory-stack/accessory-0/accessory": createTemplateReference(options.accessoriesTemplatesLegacyIds["zipper Teeth, M5"]),
        "accessories-bottom-curve/accessory-stack/accessory-0/accessory/puller-0/puller-template": createTemplateReference(
            options.accessoriesTemplatesLegacyIds["puller Square Big Hole Puller (r619) with Slider, M5"],
        ),
        "accessories-bottom-curve/accessory-stack/accessory-0/accessory/puller-0/puller-offset": 0.998,
        ...getDefaultHandlesParameters(options),
    }

    initInstanceTemplateCommon(
        modifyTemplateGraph,
        {
            legacyId: masterTemplateDataLegacyId,
            instanceName: "Simple Pocket (Master)",
            instanceId: "simple-pocket-master",
        },
        {
            ...options,
            parameters: optionsParameters,
        },
    )
}

export function initPocketWithExtraLaneMasterTemplate(
    modifyTemplateGraph: IModifyTemplateGraph,
    options: InitStackableMattressStandardModelMasterTemplateOptions = {openingOnBottom: false},
) {
    const optionsWithDefaults: InitStackableMattressStandardModelMasterTemplateOptions = {
        topPartFabricLayout: "Waterfall",
        bottomPartFabricLayout: "InvertedWaterfall",
        middlePartFabricLayout: "Border",
        ...options,
    }
    initStackableMattressStandardModelMasterTemplate(modifyTemplateGraph, optionsWithDefaults)
}

export function initPocketWithExtraLaneInstanceTemplate(
    modifyTemplateGraph: IModifyTemplateGraph,
    masterTemplateDataLegacyId: number,
    options: InitMattressInstanceTemplateOptions,
) {
    const optionsParameters = {
        ...(options.parameters ? options.parameters : {}),
        width: 90,
        length: 200,
        "top-height": 6,
        "bottom-height": 6,
        "corner-radius": 3,
        "top-radius": 2,
        "bottom-radius": 2,
        "layer-count": 1,
        "fabric-stack/layer-0/height": 6,
        "fabric-stack/layer-0/accessories-layer-top-curve/accessory-count": 1,
        "fabric-stack/layer-0/accessories-layer-top-curve/accessory-stack/accessory-0/accessory": createTemplateReference(
            options.accessoriesTemplatesLegacyIds["zipper Teeth, M5"],
        ),
        "fabric-stack/layer-0/accessories-layer-top-curve/accessory-stack/accessory-0/accessory/puller-0/puller-template": createTemplateReference(
            options.accessoriesTemplatesLegacyIds["puller Square Big Hole Puller (r619) with Slider, M5"],
        ),
        "fabric-stack/layer-0/accessories-layer-top-curve/accessory-stack/accessory-0/accessory/puller-0/puller-offset": 0.998,
        ...getDefaultHandlesParameters(options),
    }

    initInstanceTemplateCommon(
        modifyTemplateGraph,
        {
            legacyId: masterTemplateDataLegacyId,
            instanceName: "Pocket with extra lane (Master)",
            instanceId: "pocket-with-extra-lane-master",
        },
        {
            ...options,
            parameters: optionsParameters,
        },
    )
}
